export default __webpack_public_path__ + "static/media/img06.7da20611.jpg";